import { memo, useMemo } from "react";
import { ModalProps } from "../../ui/Modal";
import { createMimicMessageContext, ExpectedMessageProps, MimicMessageProviderProps } from "../MimicMessageContext";
import { ModalContainer, ModalContainerProps } from "./ModalContainer";

export type WrappedModalProps = ExpectedMessageProps & Omit<ModalProps, "isOpen" | "onRequestClose" | "overlayElement">;

const { useControls, useMessages, MessageProvider } = createMimicMessageContext<WrappedModalProps>();

export const useModal = () => useControls();
export const useConfirmation = () => {
  const controls = useControls();

  return useMemo(() => ({
    ...controls,
    push: (message: WrappedModalProps) => {
      return controls.push({
        scrollable: false,
        showCloseButton: false,
        ...message,
        cancelButtonProps: message?.cancelButtonProps !== null ? {
          children: "No",
          buttonSize: "lg",
          buttonType: "secondaryGray",
          autoFocus: true,
          ...message?.cancelButtonProps,
        } : undefined,
        submitButtonProps: message?.submitButtonProps !== null ? {
          children: "Yes",
          buttonSize: "lg",
          buttonType: "destructivePrimary",
          ...message?.submitButtonProps,
        }: undefined,
      });
    },
  }), [ controls ]);
};
export const useModalMessages = () => useMessages();

export type ModalProviderProps = MimicMessageProviderProps<WrappedModalProps> & ModalContainerProps;
export const ModalProvider = memo<ModalProviderProps>((
  {
    children,
    overlay,
    ...props
  },
) => {
  return (
    <MessageProvider {...props}>
      {children}
      <ModalContainer overlay={overlay} />
    </MessageProvider>
  );
});